export default __webpack_public_path__ + "static/SFMono-Regular-8799e6387338d58f2f137df821c86eb4.woff2";